import "./autoplaycarousel.css";

import React, { useEffect, useRef } from "react";

import CarouselItem from "./CarouselItem";

const cardDetails = {
  0: {
    imgUrl: "../Imgs/WhatIf/WHAT IFChealseaFilmFestival.png",
    imgTitle: "Chealsea Film",
  },
  1: {
    imgUrl: "../Imgs/SnowInterview/Snow behind the scenes.JPG",
    imgTitle: "Snow Interview still image",
  },

  2: {
    imgUrl: "../Imgs/TalentosLatinos.jpg",
    imgTitle: "Talentos Latinos",
  },

  3: {
    imgUrl: "../Imgs/TuAmigo/TU AMIGO TIME SQUARE.jpg",
    imgTitle: "Times Square Tu Amigo",
  },
  4: {
    imgUrl: "../Imgs/shout out LA.jpg",
    imgTitle: "ShoutLA Feature",
  },

  5: {
    imgUrl: "../Imgs/TuAmigo/Tu Amigop Poster.jpg",
    imgTitle: "Tu Amigo Especialito",
  },

  6: {
    imgUrl: "../Imgs/WalksOfLight/WalksOfLightGreenBG.jpg",
    imgTitle: "Time Square Green Background",
  },
  7: {
    imgUrl: "../Imgs/EmerestAndRoyalCare/EmerestQuickGuide.jpg",
    imgTitle: "6485 Everest",
  },
  8: {
    imgUrl: "../Imgs/EmerestAndRoyalCare/RoyalCare.jpg",
    imgTitle: "Royal Cover White Background",
  },
  9: {
    imgUrl: "../Imgs/WhatIf/whatif.jpg",
    imgTitle: "Royal Cover White Background",
  },
};

export function Carousel() {
  const containerRef = useRef(null);
  const animationRef = useRef(null);
  const lastTimeRef = useRef(null);
  const pausedRef = useRef(false);

  // Continuous scrolling speed (pixels per second). Tweak to taste.
  const SPEED_PX_PER_SEC = 60; // slower → smaller number

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Duplicate children visually by relying on layout: we'll render two copies
    // and treat the total scrollWidth as the loop length. When scrollLeft >=
    // halfScroll, we subtract halfScroll to create a seamless loop.

    let rafId = null;

    function step(now) {
      if (pausedRef.current) {
        lastTimeRef.current = now;
        rafId = requestAnimationFrame(step);
        return;
      }

      if (lastTimeRef.current == null) lastTimeRef.current = now;
      const delta = (now - lastTimeRef.current) / 1000; // seconds
      lastTimeRef.current = now;

      const scrollAmount = SPEED_PX_PER_SEC * delta;
      // advance to the right
      container.scrollLeft += scrollAmount;

      const halfScroll = container.scrollWidth / 2;
      if (container.scrollLeft >= halfScroll) {
        // wrap seamlessly
        container.scrollLeft -= halfScroll;
      }

      rafId = requestAnimationFrame(step);
    }

    // start animation
    animationRef.current = requestAnimationFrame(step);

    // Pause/resume on user interaction
    const onPointerEnter = () => (pausedRef.current = true);
    const onPointerLeave = () => (pausedRef.current = false);
    const onPointerDown = () => (pausedRef.current = true);
    const onPointerUp = () => (pausedRef.current = false);

    container.addEventListener("pointerenter", onPointerEnter);
    container.addEventListener("pointerleave", onPointerLeave);
    container.addEventListener("pointerdown", onPointerDown);
    window.addEventListener("pointerup", onPointerUp);

    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
      container.removeEventListener("pointerenter", onPointerEnter);
      container.removeEventListener("pointerleave", onPointerLeave);
      container.removeEventListener("pointerdown", onPointerDown);
      window.removeEventListener("pointerup", onPointerUp);
    };
  }, []);

  const items = Object.values(cardDetails);

  return (
    <div className="bg-offWhite mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
      <div
        ref={containerRef}
        className="overflow-x-auto flex gap-4 p-2 sm:p-4 whitespace-nowrap"
        style={{ scrollBehavior: "auto" }}
      >
        {/* Render two copies to allow seamless looping */}
        {items.concat(items).map((item, idx) => (
          <div
            key={`card-${idx}`}
            className="carousel-card flex-none sm:w-1/3 lg:w-1/4 rounded shadow-md"
          >
            <CarouselItem imgUrl={item.imgUrl} imgTitle={item.imgTitle} />
          </div>
        ))}
      </div>
    </div>
  );
}
